























export default {
    name: 'PrimaryHeader',

    props: {
        heading: {
            required: true,
            type: String,
        },
        subHeading: {
            required: false,
            type: String,
        },
        back: {
            required: false,
            type: String,
        },
    },
};
